import * as React from "react";
import { Redirect } from "react-router";

export const HomePage = () => <Redirect to="/projects" />;



// WEBPACK FOOTER //
// ./src/components/Home.tsx